import React, { useEffect, useState } from "react";
import PageLoader from "../../common/pageLoader";
import ToBeRegisteredComponent from "./toBeRegistered";
import { unregisteredFlats } from "../../../redux/slice/unregisteredFlatsSlice";
import { connect } from "react-redux";
import { Tag } from "antd";
import { societyWingList } from "../../../redux/slice/societyWingListSlice";
import { exportUnregisteredFlatList } from "../../../redux/slice/exportUnregisteredFlatListSlice";
import { useParams } from "react-router-dom";
import Notify from "../../common/notify/notify";

const ToBeRegistered = (props) => {
  const {
    unregisteredFlatsData,
    callunregisteredFlatsData,
    callsocietyWingListData,
    societyWingListData,
    callexportUnregisteredFlatListData,
  } = props;

  const { id } = useParams();

  const [selectedWingId, setSelectedWingId] = useState(null);
  const [filteredData, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const loading = societyWingListData?.loading;

  useEffect(() => {
    if (id) {
      callunregisteredFlatsData(id);
      callsocietyWingListData(id);
    }
  }, [id]);

  const wingList = societyWingListData?.societyWingListData?.data?.data || [];
  const unregisteredFlatsList =
    unregisteredFlatsData?.unregisteredFlatsData?.data?.data || [];

  useEffect(() => {
    if (unregisteredFlatsList) {
      setFilteredData(unregisteredFlatsList);
    }
  }, [unregisteredFlatsList]);

  useEffect(() => {
    const filtered = unregisteredFlatsList?.filter((flat) => {
      const matchesWing = selectedWingId
        ? flat.wing_id === selectedWingId
        : true;
      return matchesWing;
    });

    setFilteredData(filtered);
    setCurrentPage(1);
  }, [selectedWingId, unregisteredFlatsList]);

  const handleWingChange = (value) => {
    setSelectedWingId(value);
  };

  const handleClearFilters = () => {
    setSelectedWingId(null);
    setFilteredData(unregisteredFlatsList);
    setCurrentPage(1);
  };

  const handleExportData = async () => {
    try {
      const exportResult = await callexportUnregisteredFlatListData(id);

      if (exportResult.type === "exportUnregisteredFlatList/fulfilled") {
        const pdfBlob = new Blob([exportResult.payload.data], {
          type: "text/csv",
        });
        const url = window.URL.createObjectURL(pdfBlob);
        const tempLink = document.createElement("a");
        tempLink.href = url;
        document.body.appendChild(tempLink);
        tempLink.click();
        document.body.removeChild(tempLink);
        window.URL.revokeObjectURL(url);
      } else {
        Notify("error", "Oops! Something went wrong. Please try again later.", "");
      }
    } catch (error) {
      console.error("An error occurred while downloading the PDF. Please try again.", error);
    }
  };

  const user_table_columns = [
    {
      title: "Sr. No.",
      key: "serial_number",
      render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
    },
    {
      title: "Wing Name",
      dataIndex: "wing_name",
      key: "wing_name",
    },
    {
      title: "Flat Number",
      dataIndex: "flat_number",
      key: "flat_number",
    },
    {
      title: "Status",
      key: "status",
      render: () => <Tag color="volcano">Unregistered</Tag>,
    },
  ];

  return (
    <>
      {loading && <PageLoader />}

      <ToBeRegisteredComponent
        unregisteredFlatsList={unregisteredFlatsList}
        user_table_columns={user_table_columns}
        handleClearFilters={handleClearFilters}
        filteredData={filteredData}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        pageSize={pageSize}
        setPageSize={setPageSize}
        handleWingChange={handleWingChange}
        selectedWingId={selectedWingId}
        wingList={wingList}
        handleExportData={handleExportData}
      />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    unregisteredFlatsData: state.unregisteredFlats,
    societyWingListData: state.societyWingListData,
    exportUnregisteredFlatListData: state.exportUnregisteredFlatList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    callunregisteredFlatsData: (data) => dispatch(unregisteredFlats(data)),
    callsocietyWingListData: (data) => dispatch(societyWingList(data)),
    callexportUnregisteredFlatListData: (data) =>
      dispatch(exportUnregisteredFlatList(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ToBeRegistered);
